module.exports = __webpack_public_path__ + "img/15_fineStaff_ltf.ef1f2e15.png";